import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getSwaps = async ({ currencyId, pageNumber = 1 }) => {
  if (!currencyId) return Promise.resolve([]); // Prevent API call if currencyId is undefined
  console.log('Fetching swaps for:', { currencyId, pageNumber });
  return axios.get(`/transaction/swap/${currencyId}/${pageNumber}`);
};

export const useSwaps = ({ currencyId, pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['swaps', currencyId, pageNumber], // ✅ Query key now includes currencyId
    queryFn: () => getSwaps({ currencyId, pageNumber }),
    enabled: !!currencyId, // ✅ Prevents execution if currencyId is null/undefined
  });
};
